import { signOut } from "firebase/auth";
import { auth } from "../utils/resource";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDays,
  faUsers,
  faClock,
  faDollarSign,
  faArrowRightFromBracket,
  faClipboardList,
  faCheckSquare,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import "../styles/Dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();

  

  const cardData = [
    { title: "Pagamentos", path: "/payment-control", icon: faDollarSign },
    {
      title: "Frequência",
      path: "/attendance-list",
      icon: faCheckSquare,
    },
    {
      title: "Aulas",
      path: "/classes",
      icon: faCalendarDays,
    },
    { title: "Alunos", path: "/students", icon: faUsers },
    {
      title: "Horários",
      path: "/my-schedules",
      icon: faClock,
    },
    {
      title: "Avaliar Aluno",
      path: "/student-selector",
      icon: faClipboardList,
    },
  ];

  const handleLogout = async () => {
    await signOut(auth);
    localStorage.removeItem("_id");
    navigate("/");
  };

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <h1></h1>
        <FontAwesomeIcon
          icon={faArrowRightFromBracket}
          className="icon logout-icon"
          onClick={handleLogout}
        />
      </header>
      <div className="card-grid-dashboard">
        {cardData.map((card, index) => (
          <div className="card-dashboard" key={index}>
            <Link to={card.path} className="card-link-dashboard">
              <div className="card-content-dashboard">
                <FontAwesomeIcon
                  icon={card.icon}
                  className="card-icon-dashboard"
                />
                <h2>{card.title}</h2>
              </div>
              <div className="card-footer-dashboard">
                <hr className="card-line-dashboard" />
                <span className="card-text-dashboard">Acessar</span>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Dashboard;
